import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import pathBuilder from '~/utils/api'

export type TAdvanceCampaignTimePreview = {
  /** ISO date of the campaign's current logical clock. */
  campaignDate: string
  /** The checkpoint the next advance would run, or null when nothing is pending. */
  advancedTo: string | null
  /** Contacts that would advance — one outreach per contact. */
  outreachCount: number
  /** Eligible pending outreaches left after this checkpoint. */
  remainingPendingCount: number
  channels: string[]
}

const getAdvanceCampaignTimePreview = (id: string) => {
  return HttpService.get<TAdvanceCampaignTimePreview>(
    { path: pathBuilder(EServerPath.campaignAdvanceTime, { id }) },
    EHttpService.internal,
  )
}

/**
 * What the next advance would do, read from the same selection the POST uses. A GET on
 * purpose — a preview must never be able to execute a campaign step.
 */
export default function useGetAdvanceCampaignTimePreview(
  id: string,
  enabled: boolean,
) {
  return useQuery({
    queryKey: queryKeys.campaignAdvanceTimePreview(id),
    queryFn: () => getAdvanceCampaignTimePreview(id),
    enabled: Boolean(id) && enabled,
    // The checkpoint moves as soon as an advance runs, so never serve a cached one.
    staleTime: 0,
    gcTime: 0,
    retry: false,
  })
}
